var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "clearance-moulding" } },
    [
      _c(
        "nav",
        {
          staticClass:
            "navbar navigation navbar-expand-lg navbar-light bg-light",
        },
        [
          _c(
            "div",
            { staticClass: "container py-3" },
            [
              _c("search-form", {
                attrs: {
                  "max-width": 130,
                  colours: _vm.colours,
                  profiles: _vm.profiles,
                },
                on: { search: _vm.search },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-overlay",
        { staticStyle: { "min-height": "80px" }, attrs: { show: _vm.loading } },
        [
          _c(
            "div",
            { staticClass: "container pt-3" },
            [
              _vm.mouldings.length == 0 && !_vm.loading
                ? _c("h2", { staticClass: "no-results text-center" }, [
                    _vm._v("Sorry, there were no results for your search."),
                    _c("br"),
                    _vm._v("Please try a broader search."),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "row grid" },
                _vm._l(_vm.mouldings, function (moulding, index) {
                  return _c("moulding-card", {
                    key: moulding.sku,
                    attrs: { moulding: moulding },
                    on: {
                      click: function ($event) {
                        _vm.currentKey = moulding.sku
                      },
                    },
                  })
                }),
                1
              ),
              _vm.totalCount > 0
                ? _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.totalCount,
                      "per-page": _vm.perPage,
                      size: "lg",
                      align: "center",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "moulding-popup",
            size: "lg",
            title: _vm.popupTitle,
            "hide-footer": "",
            visible: _vm.currentKey !== null,
          },
          on: {
            hide: function ($event) {
              _vm.currentKey = null
            },
          },
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.mouldings.length == 0 } },
            [
              _vm.currentMoulding !== null
                ? _c("moulding-popup", {
                    attrs: { moulding: _vm.currentMoulding },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }